import { render, staticRenderFns } from "./JoinResource.vue?vue&type=template&id=170aeba7"
import script from "./JoinResource.vue?vue&type=script&lang=js"
export * from "./JoinResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports